var compareVersion = require('./compare-version');

module.exports = function (range) {
    var userAgent = ICF.Utils.GetUserAgent();
    var match = userAgent.match(/iphone(?:.+?os (\d+))?/);
    return !!match && compareVersion(match[1] || 1, range);
};